import axios from "axios";

import { IS_PRODUCTION } from "@/env";
import store from "@/store";
import router from "@/router";
import utils from "@/utils";

const apiRequest = () => {
  var token = window.localStorage.getItem("JWT");

  const instance = axios.create({
    baseURL: IS_PRODUCTION
      ? `https://${process.env.VUE_APP_B2B_ENDPOINT}/`
      : // ? "https://staging.cleed.ai/"
        "http://localhost:48080/",
    timeout: 30000,
  });
  if (token) {
    instance.defaults.headers.common.Authorization = token;
  }

  instance.interceptors.request.use((req) => {
    req.url = instance.defaults.baseURL + req.url;
    return req;
  });

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    function (error) {
      // Do something with response error
      if (error.response.status === 403 || error.response.status === 401) {
        const pathname = new URL(window.location.href).pathname;
        const checkPathMeta = utils.checkPathMeta(pathname);
        if (checkPathMeta) {
          console.log("unauthorized, logging out ...");
          store.dispatch("Unauthorized");
          router.push("404");
        }
      }
      return Promise.reject(error.response);
    }
  );
  return instance;
};

export { apiRequest };
